<div class="container">

    <ng-container *ngIf="!_expandable">
        <app-banner *ngIf="bannerData.showNuveiBanner" [type]="nuveiBannerType">
            <app-icon leading src="close" style="z-index: 9" class="se-icon-button no-bg" width="24px" height="24px" (click)="dismissBannerClick()"></app-icon>
            <p *ngIf="[null, 'created'].includes(bannerData.applicationStatus)" trailing class="simple-text-button banner-text green-button" (click)="startNuveiApplicationClick()">{{ bannerData.applicationStatus === null ? 'Start >' : 'Continue >' }}</p>
            <p content class="banner-text">{{ nuveiStatusMessage }}</p>
            <p *ngIf="bannerData.applicationStatus === 'missing_data'" trailing class="simple-text-button banner-text" (click)="navigateToSettings('Business')">View in Settings ></p>
        </app-banner>
        <app-banner *ngIf="bannerData.showCourseBanner" class="course" type="primary">
            <p trailing class="simple-text-button banner-text" (click)="viewCourseButtonClick()">View in Settings ></p>
            <p content class="banner-text">
                Watch a 30 minute course to learn the in‑and‑outs of the system
            </p>
        </app-banner>
    </ng-container>

    <div *ngIf="_expandable" class="banner-wrapper expandable" [class.p--12]="smallScreen$ | async">
        <div class="expansion-toggle" (click)="_expanded = !_expanded"></div>
        <div class="d-flex justify-content-between align-items-center w-100 h--56">
            <div class="d-flex align-items-center gap--20">
                <app-icon src="close" style="z-index: 9" class="se-icon-button no-bg" width="24px" height="24px" (click)="dismissBannerClick()"></app-icon>
                <p class="banner-text">Unlock System Tips & Payments Setup</p>
            </div>
            <app-icon src="chevron" [class.rotate]="_expanded" display="block" width="24px" height="24px"></app-icon>
        </div>
        <div class="expansion-content" [class.expanded]="_expanded">
            <div class="divider"></div>
            <app-banner *ngIf="bannerData.showCourseBanner" class="course" type="primary">
                <p trailing class="simple-text-button banner-text" (click)="viewCourseButtonClick()">View in Settings ></p>
                <p content class="banner-text">
                    Watch a 30 minute course to learn the in‑and‑outs of the system
                </p>
            </app-banner>
            <app-banner *ngIf="bannerData.showNuveiBanner" class="payments" [type]="nuveiBannerType">
                <p *ngIf="[null, 'created'].includes(bannerData.applicationStatus)" trailing class="simple-text-button banner-text green-button" (click)="startNuveiApplicationClick()">{{ bannerData.applicationStatus === null ? 'Start >' : 'Continue >' }}</p>
                <p content class="banner-text">{{ nuveiStatusMessage }}</p>
                <p *ngIf="bannerData.applicationStatus === 'missing_data'" trailing class="simple-text-button banner-text" (click)="navigateToSettings('Business')">View in Settings ></p>
            </app-banner>
        </div>
    </div>
</div>